import WorkspaceTile from './WorkspaceTile.jsx'
import AddWorkspaceTile from './AddWorkspaceTile.jsx'
import WorkspaceTilesSkeleton from './WorkspaceTilesSkeleton.jsx'
import styles from './WorkspaceTiles.module.scss'

export default function WorkspaceTilesScroll({ query, workspaces, activeId, onSelect, onAdd }) {
  return (
    <div className={styles.scroll} aria-busy={query.isLoading}>
      {query.isLoading ? <WorkspaceTilesSkeleton /> : null}
      {query.isError ? (
        <button
          type="button"
          className={styles.retry}
          aria-label="Retry loading workspaces"
          onClick={() => void query.refetch()}
        >
          ↻
        </button>
      ) : null}
      {!query.isLoading
        ? workspaces.map((workspace) => (
            <WorkspaceTile
              key={workspace.id}
              workspace={workspace}
              active={workspace.id === activeId}
              onSelect={onSelect}
            />
          ))
        : null}
      {!query.isLoading && !query.isError ? <AddWorkspaceTile onClick={onAdd} /> : null}
    </div>
  )
}
